import { Button } from "antd";
import wallet from "assets/images/wallet.png";
import { LocalContext } from "context/AuthenticationContext";
import { Dispatch, PureComponent, ReactNode, SetStateAction } from "react";
import { NumberFormat } from "utils/format/NumberFormat";
import { strings } from "utils/localizedStrings";
import NotificationFeature from "./header/notification/views/NotificationFeature";
import UserMenu from "./header/UserMenu";
import TopupInfoModal from "./modals/TopupInfoModal";

interface IHeaderFeture {
  sidebarOpen: boolean;
  setSidebarOpen: Dispatch<SetStateAction<boolean>>;
}

interface HeaderState {
  openTopupModal: boolean;
}

export default class Header extends PureComponent<IHeaderFeture, HeaderState> {
  static contextType = LocalContext;
  context: React.ContextType<typeof LocalContext>;

  constructor(props: IHeaderFeture) {
    super(props);
    this.state = { openTopupModal: false };
  }

  render(): ReactNode {
    const { sidebarOpen, setSidebarOpen } = this.props;
    const { user } = this.context;
    return (
      <header className="sticky top-0 bg-white xxl:w-screen w-7xl h-[68px] border-b border-gray-200 z-30">
        <div className="px-2 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Header: Left side */}
            <div className="flex">
              {/* Hamburger button */}
              <button
                className="text-gray-500 hover:text-gray-600 xl:hidden"
                aria-controls="sidebar"
                aria-expanded={sidebarOpen}
                onClick={() => setSidebarOpen(!sidebarOpen)}
              >
                <span className="sr-only">Open sidebar</span>
                <svg
                  className="w-6 h-6 fill-current"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="4" y="5" width="16" height="2" />
                  <rect x="4" y="11" width="16" height="2" />
                  <rect x="4" y="17" width="16" height="2" />
                </svg>
              </button>
            </div>

            {/* Header: Right side */}
            <div className="flex items-center lg:gap-x-8 gap-x-1">
              <div className="flex justify-center items-center gap-x-2">
                <img
                  src={wallet}
                  alt="balance"
                  className="lg:flex hidden object-contain xl:h-[35px] h-[25px] xl:w-[35px] w-[25px]"
                />
                <p className="lg:flex hidden xl:text-[14px] text-[11px] text-[#909090]">
                  {strings.GlobalLabels.Balance}
                </p>
                <p className="lg:flex hidden xl:text-[17px] text-[14px] font-[700]">{`${NumberFormat.currencyFormat(
                  user?.balance ?? 0,
                )}`}</p>
                {user?.role?.code?.includes("partner") ? (
                  <Button
                    type="primary"
                    size="small"
                    style={{
                      textAlign: "center",
                      padding: 7,
                      borderRadius: 50,
                    }}
                    onClick={() => this.setState({ openTopupModal: true })}
                  >
                    <p className="xl:text-[13px] text-[11px] font-[500]">{`${strings.GlobalLabels.Topup}+`}</p>
                  </Button>
                ) : null}
              </div>
              <TopupInfoModal
                open={this.state.openTopupModal}
                onClose={() => this.setState({ openTopupModal: false })}
              />
              {/* <SearchModal /> */}
              <NotificationFeature />
              {/* <Help /> */}
              {/*  Divider */}
              <UserMenu />
              {/* <LanguageSwitching
                data={{
                  language,
                  getSidebar,
                  user,
                  setLanguage,
                  color: "#000000",
                }}
              /> */}
            </div>
          </div>
        </div>
      </header>
    );
  }
}
